const WEB_EN_ATTENTE = 'Réservation web en attente';

export default WEB_EN_ATTENTE;
